export interface CardLayoutInput {
    key: string;
    label: string;
    referenceId?: string[];
}

export class CardLayout {
    /**
     * Key of the layout to be displayed.
     */
    public key: string;

    /**
     * Label that will be displayed to the end-user
     */
    public label: string;

    /**
     * CMS content meta option value reference ID
     */
    public referenceId?: string[];

    public constructor(input: CardLayoutInput) {
        this.key = input.key;
        this.label = input.label;
        this.referenceId = input.referenceId || [];
    }
}
